import { render, staticRenderFns } from "./AssignButton.vue?vue&type=template&id=89a539ca"
import script from "./AssignButton.vue?vue&type=script&lang=js"
export * from "./AssignButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports